'use client'

import type { SKUSelectorDropdownProps } from '@src/components/SKUSelectorDropdown/SKUSelectorDropdownProps'

const defaultContentTop1 = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    layerName: 'BuilderContentOption1',
    meta: { naturalWidth: 742.0313110351562 },
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-bc1421a24c5d484d84a2e45d2478c5a5' },
        children: [
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: {
              'transformed.text': 'localized',
              localizedTextInputs: ['text'],
              previousId: 'builder-627a5955c8a344a8beaa25710a8d6ec1',
            },
            component: {
              name: 'Text',
              options: {
                getValueFromCountdown: false,
                style: 'Body MD - Medium weight',
                actionName: 'none',
                navigate: { href: '/', analyticsEvent: 'none' },
                text: {
                  '@type': '@builder.io/core:LocalizedValue',
                  Default: '<p>Content top 1</p>',
                },
              },
            },
            responsiveStyles: {
              large: {
                position: 'relative',
                height: 'auto',
                textAlign: 'center',
                marginRight: 'auto',
              },
            },
          },
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-93c232b1f7c74ecdb77bdb0c3829d70d' },
            children: [
              {
                '@type': '@builder.io/sdk:Element',
                '@version': 2,
                meta: {
                  'transformed.text': 'localized',
                  localizedTextInputs: ['text'],
                  previousId: 'builder-a3e2ebead65a4d1e8f248f259ea97f2c',
                },
                component: {
                  name: 'Text',
                  options: {
                    getValueFromCountdown: false,
                    style: 'Body MD - Medium weight',
                    actionName: 'none',
                    navigate: { href: '/', analyticsEvent: 'none' },
                    text: '<p><s>$179</s> <span style="color: rgb(208, 2, 27);">$119/yr (72% off)</span></p>',
                  },
                },
                responsiveStyles: {
                  large: {
                    position: 'relative',
                    height: 'auto',
                    textAlign: 'center',
                    marginLeft: 'auto',
                  },
                  small: { textAlign: 'right' },
                },
              },
              {
                '@type': '@builder.io/sdk:Element',
                '@version': 2,
                meta: {
                  'transformed.text': 'localized',
                  localizedTextInputs: ['text'],
                  previousId: 'builder-0e48dd43e2bd4fed9be1352b16879a44',
                },
                component: {
                  name: 'Text',
                  options: {
                    getValueFromCountdown: false,
                    style: 'Body XS',
                    actionName: 'none',
                    navigate: { href: '/', analyticsEvent: 'none' },
                    text: "<p>That's only $9.92 per month! 👆</p>",
                  },
                },
                responsiveStyles: {
                  large: {
                    position: 'relative',
                    height: 'auto',
                    textAlign: 'center',
                    marginLeft: 'auto',
                    display: 'flex',
                  },
                  medium: { display: 'flex' },
                  small: { textAlign: 'right', display: 'none' },
                },
              },
            ],
            responsiveStyles: { large: { position: 'relative' } },
          },
        ],
        responsiveStyles: {
          large: { position: 'relative', display: 'flex', marginBottom: '0.5em' },
        },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: {
          'transformed.text': 'localized',
          localizedTextInputs: ['text'],
          previousId: 'builder-7681db5dd9344be2b79ac2ecdcb0a8c8',
        },
        component: {
          name: 'Text',
          options: {
            getValueFromCountdown: false,
            style: 'Body SM',
            actionName: 'none',
            navigate: { href: '/', analyticsEvent: 'none' },
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default:
                '<p>New Customers** get 72% off the Monthly Plan! $119 billed today for the first year, then billed annually at $179*.</p>',
            },
          },
        },
        responsiveStyles: {
          large: {
            position: 'relative',
            height: 'auto',
            textAlign: 'left',
            marginRight: 'auto',
            marginBottom: '0.5em',
          },
        },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-6912acf1d14d46fda8ead4e207f668cb' },
        component: {
          name: 'Columns',
          options: {
            columns: [
              {
                blocks: [
                  {
                    '@type': '@builder.io/sdk:Element',
                    '@version': 2,
                    meta: {
                      previousId: 'builder-5cbeab9e31e84a6c94ade5aca3edf20f',
                      'transformed.items.0.value': 'localized',
                      'transformed.items.1.value': 'localized',
                    },
                    component: {
                      name: 'Checklist',
                      options: {
                        textStyle: 'Body SM',
                        items: [
                          { value: '<p>Access to 21 Day Fix Program.</p>' },
                          {
                            value:
                              '<p>1000s of workouts including cardio, weightlifting and yoga </p>',
                          },
                        ],
                        checkColor: 'var(--color-bodi-accent-deep-500)',
                        checkIcon: 'CheckIcon',
                        iconType: 'solid',
                        iconSize: 16,
                        separation: 8,
                      },
                    },
                    responsiveStyles: { large: { position: 'relative' } },
                  },
                ],
              },
              {
                blocks: [
                  {
                    '@type': '@builder.io/sdk:Element',
                    '@version': 2,
                    meta: {
                      previousId: 'builder-000d69530ee741e29c26de14100949ac',
                      'transformed.items.1.value': 'localized',
                      'transformed.items.0.value': 'localized',
                    },
                    component: {
                      name: 'Checklist',
                      options: {
                        textStyle: 'Body SM',
                        items: [
                          { value: '<p>130+ fitness programs included.</p>' },
                          { value: '<p>All BODi Super Trainers</p>' },
                        ],
                        checkColor: 'var(--color-bodi-accent-deep-500)',
                        checkIcon: 'CheckIcon',
                        iconType: 'solid',
                        iconSize: 16,
                        separation: 8,
                      },
                    },
                    responsiveStyles: { large: { position: 'relative' } },
                  },
                ],
              },
            ],
            space: 20,
            stackColumnsAt: 'tablet',
            reverseColumnsWhenStacked: false,
          },
        },
        responsiveStyles: { large: { position: 'relative' } },
      },
    ],
    responsiveStyles: { large: { marginBottom: '24px' } },
  },
]
const defaultContentTop2 = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    layerName: 'BuilderContentOption2',
    meta: { naturalWidth: 742.0313110351562 },
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-801165135bf9499bb99a828ef8034cb8' },
        children: [
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: {
              'transformed.text': 'localized',
              localizedTextInputs: ['text'],
              previousId: 'builder-b0eafaba7f3e4efea814ef083fdec8fb',
            },
            component: {
              name: 'Text',
              options: {
                getValueFromCountdown: false,
                style: 'Body MD - Medium weight',
                actionName: 'none',
                navigate: { href: '/', analyticsEvent: 'none' },
                text: {
                  '@type': '@builder.io/core:LocalizedValue',
                  Default: '<p>Content top 2</p>',
                },
              },
            },
            responsiveStyles: {
              large: {
                position: 'relative',
                height: 'auto',
                textAlign: 'center',
                marginRight: 'auto',
              },
            },
          },
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-f29197bfe99a4e698adfc551505d93e4' },
            children: [
              {
                '@type': '@builder.io/sdk:Element',
                '@version': 2,
                meta: {
                  'transformed.text': 'localized',
                  localizedTextInputs: ['text'],
                  previousId: 'builder-d6b9bc9b022d448eaf8bc94d9c6b7470',
                },
                component: {
                  name: 'Text',
                  options: {
                    getValueFromCountdown: false,
                    style: 'Body MD - Medium weight',
                    actionName: 'none',
                    navigate: { href: '/', analyticsEvent: 'none' },
                    text: {
                      '@type': '@builder.io/core:LocalizedValue',
                      Default:
                        '<p><s>$179</s> <span style="color: rgb(208, 2, 27);">$999/yr (72% off)</span></p>',
                    },
                  },
                },
                responsiveStyles: {
                  large: {
                    position: 'relative',
                    height: 'auto',
                    textAlign: 'center',
                    marginLeft: 'auto',
                  },
                  small: { textAlign: 'right' },
                },
              },
              {
                '@type': '@builder.io/sdk:Element',
                '@version': 2,
                meta: {
                  'transformed.text': 'localized',
                  localizedTextInputs: ['text'],
                  previousId: 'builder-3969634b5e734cff9e99e13da250eab7',
                },
                component: {
                  name: 'Text',
                  options: {
                    getValueFromCountdown: false,
                    style: 'Body XS',
                    actionName: 'none',
                    navigate: { href: '/', analyticsEvent: 'none' },
                    text: "<p>That's only $9.92 per month! 👆</p>",
                  },
                },
                responsiveStyles: {
                  large: {
                    position: 'relative',
                    height: 'auto',
                    textAlign: 'center',
                    marginLeft: 'auto',
                    display: 'flex',
                  },
                  medium: { display: 'flex' },
                  small: { textAlign: 'right', display: 'none' },
                },
              },
            ],
            responsiveStyles: { large: { position: 'relative' } },
          },
        ],
        responsiveStyles: {
          large: { position: 'relative', display: 'flex', marginBottom: '0.5em' },
        },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: {
          'transformed.text': 'localized',
          localizedTextInputs: ['text'],
          previousId: 'builder-2414bc0c8c7748ceaad4eb55ebfed91b',
        },
        component: {
          name: 'Text',
          options: {
            getValueFromCountdown: false,
            style: 'Body SM',
            actionName: 'none',
            navigate: { href: '/', analyticsEvent: 'none' },
            text: {
              '@type': '@builder.io/core:LocalizedValue',
              Default:
                '<p>New Customers** get 72% off the Monthly Plan! $119 billed today for the first year, then billed annually at $179*.</p>',
            },
          },
        },
        responsiveStyles: {
          large: {
            position: 'relative',
            height: 'auto',
            textAlign: 'left',
            marginRight: 'auto',
            marginBottom: '0.5em',
          },
        },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-fc5cf957d70b422b807472ba96a8285b' },
        component: {
          name: 'Columns',
          options: {
            columns: [
              {
                blocks: [
                  {
                    '@type': '@builder.io/sdk:Element',
                    '@version': 2,
                    meta: {
                      previousId: 'builder-5cbeab9e31e84a6c94ade5aca3edf20f',
                      'transformed.items.0.value': 'localized',
                      'transformed.items.1.value': 'localized',
                      localizedTextInputs: ['items.1.value'],
                    },
                    component: {
                      name: 'Checklist',
                      options: {
                        textStyle: 'Body SM',
                        items: [{ value: '<p>Access to 21 Day Fix Program.</p>' }],
                        checkColor: 'var(--color-bodi-accent-deep-500)',
                        checkIcon: 'CheckIcon',
                        iconType: 'solid',
                        iconSize: 16,
                        separation: 8,
                      },
                    },
                    responsiveStyles: { large: { position: 'relative' } },
                  },
                ],
              },
              {
                blocks: [
                  {
                    '@type': '@builder.io/sdk:Element',
                    '@version': 2,
                    meta: {
                      previousId: 'builder-000d69530ee741e29c26de14100949ac',
                      'transformed.items.1.value': 'localized',
                      'transformed.items.0.value': 'localized',
                    },
                    component: {
                      name: 'Checklist',
                      options: {
                        textStyle: 'Body SM',
                        items: [{ value: '<p>130+ fitness programs included.</p>' }],
                        checkColor: 'var(--color-bodi-accent-deep-500)',
                        checkIcon: 'CheckIcon',
                        iconType: 'solid',
                        iconSize: 16,
                        separation: 8,
                      },
                    },
                    responsiveStyles: { large: { position: 'relative' } },
                  },
                ],
              },
            ],
            space: 20,
            stackColumnsAt: 'tablet',
            reverseColumnsWhenStacked: false,
          },
        },
        responsiveStyles: { large: { position: 'relative' } },
      },
    ],
    responsiveStyles: { large: { marginBottom: '24px' } },
  },
]

export const SKUSelectorDropdownDefaults: SKUSelectorDropdownProps = {
  previewAllItems: true,
  cta: {
    label: 'Get Offer',
    variant: 'primary',
    redirectUrl: '/cart',
  },
  options: [
    {
      sku: '123',
      label: 'Option 1',
      descriptor: 'Bestseller',
      contentTop: defaultContentTop1,
      hasImage: true,
      image: {
        src: 'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F6d4d65f5eb00485dbcae5599cf76d808?format=webp',
        altText: 'Option 1',
        width: 16,
        height: 16,
        rightSpacing: 16,
      },
    },
    {
      sku: '321',
      label: 'Option 2',
      descriptor: 'Bestseller',
      contentTop: defaultContentTop2,
      hasImage: true,
      image: {
        src: 'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F01e77beb89ae4a8297996245125d6d4a?format=webp',
        altText: 'Option 2',
        width: 16,
        height: 16,
        rightSpacing: 16,
      },
    },
  ],
}
